import {axios} from "@/api/config";
// 查询风险分析单元管理列表
export function listRiskUnit(params) {
  return axios.get(`/riskUnit/list`, params, true);
}

// 查询风险分析单元管理详细
export function getRiskUnit(riskUnitId) {
  return axios.get(`/riskUnit/${riskUnitId}`, riskUnitId, true)
}

// 新增风险分析单元管理
export function addRiskUnit(params) {
  return axios.post('/riskUnit/addRiskUnit', params, false);
}

// 修改风险分析单元管理
export function updateRiskUnit(params) {
  return axios.post('/riskUnit/editRiskUnit', params, false);
}


// 删除风险分析单元管理
export function delRiskUnit(riskUnitId) {
  return axios.delete(`/riskUnit/${riskUnitId}`, true)
}

